"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDesktopSessionLoginData = void 0;
/**
 * Build login message object for Desktop Session streaming connection
 *
 * @param params Parameters for Desktop session authentication for streaming connection
 */
function buildDesktopSessionLoginData(params) {
    const { appKey, accessToken, tokenType } = params;
    return {
        applicationId: void 0,
        appKey,
        position: 'localhost',
        authorization: accessToken ? `${tokenType} ${accessToken}` : undefined,
    };
}
exports.buildDesktopSessionLoginData = buildDesktopSessionLoginData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtZGVza3RvcC1zZXNzaW9uLWxvZ2luLWRhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2Vzc2lvbi9kZXNrdG9wL2J1aWxkLWRlc2t0b3Atc2Vzc2lvbi1sb2dpbi1kYXRhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBOzs7O0dBSUc7QUFDSCxTQUFnQiw0QkFBNEIsQ0FBQyxNQUF5QjtJQUNsRSxNQUFNLEVBQUUsTUFBTSxFQUFFLFdBQVcsRUFBRSxTQUFTLEVBQUUsR0FBRyxNQUFNLENBQUM7SUFFbEQsT0FBTztRQUNILGFBQWEsRUFBRSxLQUFLLENBQUM7UUFDckIsTUFBTTtRQUNOLFFBQVEsRUFBRSxXQUFXO1FBQ3JCLGFBQWEsRUFBRSxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQUcsU0FBUyxJQUFJLFdBQVcsRUFBRSxDQUFDLENBQUMsQ0FBQyxTQUFTO0tBQ3pFLENBQUM7QUFDTixDQUFDO0FBVEQsb0VBU0MifQ==